import { batch } from "@preact/signals-react";
import axios from "axios";
import {
  templateContinuationToken,
  templateHasMore,
  templateHistoryData,
  templateHistoryError,
  templateHistoryStatus,
} from "./TemplateHistorySignals";

const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT;

/**
 * Fetch template history by template ID
 */
export const getTemplateHistory = async (templateId, isLoadMore = false) => {
  try {
    batch(() => {
      templateHistoryStatus.value = "loading";
      if (!isLoadMore) {
        templateHistoryData.value = [];
        templateContinuationToken.value = null;
      }
    });

    const params = {
      resourceType: "Template",
      resourceId: templateId,
      maxItemCount: 100,
    };

    if (isLoadMore && templateContinuationToken.value) {
      params.continuationToken = templateContinuationToken.value;
    }

    const response = await axios.get(`${API_BASE_URL}/api/AuditTrail/GetAuditTrailByResourceId`, {
      params,
    });

    const items = response.data.items || response.data.Items || [];
    const continuationToken = response.data.continuationToken || response.data.ContinuationToken;
    const hasMore =
      response.data.hasMore === undefined ? response.data.HasMore : response.data.hasMore;

    batch(() => {
      if (isLoadMore) {
        templateHistoryData.value = [...templateHistoryData.value, ...items];
      } else {
        templateHistoryData.value = items || [];
      }
      templateContinuationToken.value = continuationToken;
      templateHasMore.value = hasMore;
      templateHistoryStatus.value = "loaded";
      templateHistoryError.value = null;
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching template history:", error);
    batch(() => {
      templateHistoryStatus.value = "error";
      templateHistoryError.value =
        error.response?.data?.message || error.message || "Failed to fetch template history";
    });
    throw error;
  }
};

/**
 * Load more template history data
 */
export const loadMoreTemplateHistory = async (templateId) => {
  if (!templateHasMore.value || !templateId) return;
  await getTemplateHistory(templateId, true);
};

/**
 * Clear all template history data
 */
export const clearTemplateHistory = () => {
  batch(() => {
    templateHistoryData.value = [];
    templateHistoryStatus.value = "idle";
    templateHistoryError.value = null;
    templateContinuationToken.value = null;
    templateHasMore.value = false;
  });
};
